import styled from "@emotion/styled";

export const PolicyPageContent = styled.div`
  max-width: 990px;
  margin: auto;
`;
